module.exports = TipTap;


//////////////////
// WEBPACK FOOTER
// external "TipTap"
// module id = 263
// module chunks = 0 1